import { createScopedDescriptor } from 'quartz/globalState/api';
export const HISTORY_INSTANCE = createScopedDescriptor('historyInstance', 'EXECUTION_CONTEXT');
export const HISTORY_BASE_PATH = createScopedDescriptor('historyBasePath', 'EXECUTION_CONTEXT');
/**
 * Cross-app navigator installed by the Granite host, present only while a host
 * is active. BROWSING_CONTEXT (not execution-scoped) so every remote reaches
 * the same one; `navigate()` falls back to app history when it is absent.
 */
export const GRANITE_NAVIGATE = createScopedDescriptor('graniteNavigate', 'BROWSING_CONTEXT');